import { CommonConst, CommonStorageKey } from "../const";
import { Router } from "@angular/router";

/**
 * 画面遷移に関するユーティリティクラスです。
 */
export class RedirectUtil {
  // 画面遷移
  public static toMaintenance(result: object, router: Router): boolean {
    // システムエラー
    if (result[0].rtnCode == CommonConst.C_RTN_CODE_SYSTEM_ERR) {
      router.navigateByUrl('/ne01', { skipLocationChange: true });
      return true;
    }
    // 非稼働
    if (result[0].rtnCode == CommonConst.C_RTN_CODE_HIKADOU) {
      sessionStorage.setItem(CommonStorageKey.NEMESSAGE, result[0].neMessage);
      router.navigateByUrl('/ne03', { skipLocationChange: true });
      return true;
    }
    // メンテ中
    if (result[0].rtnCode == CommonConst.C_RTN_CODE_MENTETYU) {
      sessionStorage.setItem(CommonStorageKey.NEMESSAGE, result[0].neMessage);
      router.navigateByUrl('/ne04', { skipLocationChange: true });
      return true;
    }
    // 動作確認外ブラウザ
    if (result[0].rtnCode == CommonConst.C_RTN_CODE_NG_BROWSER) {
      sessionStorage.setItem(CommonStorageKey.NEMESSAGE, result[0].neMessage);
      router.navigateByUrl('/ne06', { skipLocationChange: true });
      return true;
    }
        // セッションタイムアウト
    if (result[0].rtnCode == CommonConst.C_RTN_CODE_TIMEOUT) {
      // ST-567 ログアウト後に不要なセッションタイムアウトの画面を表示する。 MOD START
      if (document.getElementById("left_menu") != null) {
        router.navigateByUrl('/ne99', { skipLocationChange: true });
      }
      // ST-567 MOD END
      return true;
    }
    // ログイン
    if (result[0].rtnCode == CommonConst.C_RTN_CODE_LOGIN) {
      // 強化テスト No.153 Start
      if (document.getElementById("left_menu") != null) {
        sessionStorage.clear();
      }
      // 強化テスト No.153 End
      router.navigateByUrl('/n5011');
      return true;
    }
    // 画面遷移しない
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/utility/redirect-util.ts